import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;

export const getContractInvoiceList = (queryParams = "") =>
  instance({ baseURL }).get("/contract-invoice" + queryParams);

export const updateContractInvoiceStatus = (invoiceId, body) =>
  instance({ baseURL }).patch(`/contract-invoice/${invoiceId}/status`, body);
